/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_I18n_DescriptionInputs */

const en_landing_features_i18n_description = /** @type {(inputs: Landing_Features_I18n_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English and Chinese built-in with locale-aware routing. Easy to extend with additional languages.`)
};

const zh_landing_features_i18n_description = /** @type {(inputs: Landing_Features_I18n_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内置中英文支持，路由感知语言切换，轻松扩展更多语言。`)
};

/**
* | output |
* | --- |
* | "English and Chinese built-in with locale-aware routing. Easy to extend with additional languages." |
*
* @param {Landing_Features_I18n_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_i18n_description = /** @type {((inputs?: Landing_Features_I18n_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_I18n_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_i18n_description(inputs)
	return zh_landing_features_i18n_description(inputs)
});
export { landing_features_i18n_description as "landing.features.i18n.description" }